module.exports = __webpack_public_path__ + "img/whatsapp_gray.89dba070.svg";